/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  PersonInfo,
  PersonGroupMember,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  personInfoSchema,
  personGroupMemberSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
  personInfoJsonSchema,
  personGroupMemberJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema } from './enumLib_api';
export const holidaySchema = z.object({
	Date: z.coerce.date(),
	Label: z.string(),
	Type: z.int()
});

export const holidayJsonSchema = z.object({
	Date: z.iso.datetime({ local: true }),
	Label: z.string(),
	Type: z.int()
});

/** Responsible: ERLE, Updated: 20230522 */
export class Holiday {
	constructor(
		public Date: Date,
		public Label: string,
		public Type: number,
	) {}
}

export const holidayResponseSchema = z.object({
	Holidays: z.array(z.lazy(() => holidaySchema))
});

export const holidayResponseJsonSchema = z.object({
	Holidays: z.array(z.lazy(() => holidayJsonSchema))
});

/** Responsible: ERLE, Updated: 20230522 */
export class HolidayResponse {
	constructor(
		public Holidays: Holiday[],
	) {}
}

/**
	Returns the list of holidays (not scoped in time)
	Responsible: ERLE, Updated: 20230522
*/
export class GetHolidays extends WebRequest<HolidayResponse> {
	public readonly webService = "calendar";
	public readonly method = "GetHolidays";
	public readonly noUserValidation = true;
	public readonly noAuditAction = true;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetHolidays => {
        return new GetHolidays();
          }
	public static readonly returnSchema = z.lazy(() => holidayResponseSchema);
	public resultFromJSON(json: WebResponseResult<HolidayResponse>): HolidayResponse {
		return validate(GetHolidays.returnSchema, json) as unknown as HolidayResponse;
	}
}

export const GetHolidaysAI = { key: 'calendar_GetHolidays' as const,
          webService: 'calendar' as const,
           method: 'GetHolidays' as const,
           description: "Returns the list of holidays (not scoped in time)",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => holidayResponseJsonSchema),
          outputSchema: z.lazy(() => holidayResponseSchema),
          requestClass: GetHolidays
          }
export const endpoints = [GetHolidaysAI] as const;
export type Endpoint = (typeof endpoints)[number];
